<template>
  <detail-layout-full-width>
    <template slot="header">
      <BaseHeader :content="header" />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
        >
          <div class="lg:max-w-detail lg:mr-auto">
              <div class="mt-2">
                <el-table
                  ref="metadatos"
                  :data="form.Metadatos"
                  style="width: 100%"
                  :show-header="true">
                  <el-table-column
                    prop="Campo"
                    label="Campo"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    prop="Valor"
                    label="Valor"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    prop="actions"
                    width="80"
                    align="center"
                    label="-">
                    <template slot-scope="scope">
                    <div class="flex flex-row">
                      <base-button-icon @click="editMetadatoAdicional(scope.row)" name="editpencil" mode="core" size="xs" ariaLabel="Editar metadato" />
                      <base-button-icon @click="deleteMetadatoAdicional(scope.row)" name="trash" mode="core" size="xs" ariaLabel="Eliminar metadato" />
                    </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
          </div>
        </el-form>
      </div>
      </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive
            mode="primary"
            :text="$t('notificationFilter.new_metadata')"
            icon="plus"
            @click="newMetadato()"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
        </template>
      </base-footer>
      <notification-new-metadata-dialog 
        :dialogOpen="showNewMetadato" 
        :idCliente="this.form.idCliente"
        :idRegla="this.id"
        @toggleDialog="toggleDialogMetadato" 
        @applyDialog="applyDialogMetadatoHandler"
      />
      <notification-update-metadata-dialog 
        :dialogOpen="showUpdateMetadato" 
        :campo="this.selectedUpdateMetadataCampo" 
        :valorDefecto="this.selectedUpdateMetadataValor" 
        :idRegla="this.id"
        :idCliente="this.form.idCliente"
        @toggleDialog="toggleDialogUpdateMetadato" 
        @applyDialog="applyDialogUpdateMetadatoHandler"/>
    </template>
  </detail-layout-full-width>
</template>

<script>
import DetailLayoutFullWidth from '../../components/layout/DetailLayoutFullWidth.vue'
import NotificationNewMetadataDialog from '../../components/NotificationNewMetadataDialog.vue'
import NotificationUpdateMetadataDialog from '../../components/NotificationUpdateMetadataDialog.vue'
import { getRule } from '@/services/configurations/rules/getRule'
import { getMetadatosRegla } from '@/services/configurations/rules/getMetadatosRegla'
import { deleteMetadatoRegla } from '@/services/configurations/rules/deleteMetadatoRegla'
import { i18n } from '@/i18n'
import BaseFooter from '../../components/base/BaseFooter.vue'

export default {
  /* eslint-disable camelcase */
  name: 'metadata-by-rule',
  components: {
    DetailLayoutFullWidth,
    NotificationNewMetadataDialog,
    NotificationUpdateMetadataDialog,
    BaseFooter,
  },
  data: function () {
    return {
      activeName: 'es',
      header: {
        title: i18n.t('app.metadata'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'configurations/rules/details',
      },
      showNewMetadato: false,
      showUpdateMetadato: false,
      selectedUpdateMetadataCampo: '',
      selectedUpdateMetadataValor: '',
      numMaxMetadata: 10,
      form: {
        Metadatos: [],
        idCliente: -1,
      },
      rules: {}
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    id () {
      return parseInt(this.$route.params.id)
    }
  },
  created: async function () {
    const breadcrumbs = []
    if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
      breadcrumbs.push({
        path: this.role === 'SuperAdministrador' ? 'configurationssa' : 'configurations',
        name: this.$i18n.t('app.configurations')
      })
    } else {
      breadcrumbs.push({
        path: 'configurations',
        name: this.$i18n.t('app.configurations')
      })
    }
    breadcrumbs.push({ path: 'configurations/rules', name: this.$i18n.t('app.rules') })
    const rule = await this.downloadRuleData(this.id)
    this.form.idCliente = rule.idEmpresa
    breadcrumbs.push({ path: '', name: rule.Nombre })
    this.$store.commit('app/setheaderBreadCrumb', rule.Nombre)

    this.header.breadcrumb = breadcrumbs

    await this.downloadData()
  },
  mounted () {
  },
  methods: {
    toggleDialogMetadato: function () {
      this.showNewMetadato = !this.showNewMetadato
    },
    newMetadato: async function () {
      this.toggleDialogMetadato()
    },
    editMetadatoAdicional: async function (row) {
      this.selectedUpdateMetadataCampo = row.Campo
      this.selectedUpdateMetadataValor = row.Valor
      this.toggleDialogUpdateMetadato()
    },
    toggleDialogUpdateMetadato: function () {
      this.showUpdateMetadato = !this.showUpdateMetadato
    },
    applyDialogMetadatoHandler: async function () {
      this.downloadData()
      this.toggleDialogMetadato()
    },
    applyDialogUpdateMetadatoHandler: async function () {
      this.downloadData()
      this.toggleDialogUpdateMetadato()
    },
    deleteMetadatoAdicional: async function (row) {
      try {
        this.$store.commit('app/setLoading', true)
        const response = await deleteMetadatoRegla({ Campo: row.Campo, idRegla: this.id })
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.downloadData()
          this.doFeedback('Metadato eliminado correctamente', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    },
    ///
    downloadRuleData: async function (idRegla) {
      let rule = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idRegla: idRegla
        }
        rule = await getRule(params)
        if (rule.blnError) {
          this.doFeedback(rule.msgError + ' [Código de error: ' + rule.codError + ']')
        }
        return rule.Respuesta
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadData: async function () {
      try {
        const params = { idRegla: this.id }
        const result = await getMetadatosRegla(params)
        if (result.blnError) {
          this.doFeedback(result.msgError + ' [Código de error: ' + result.codError + ']')
        } else {
          this.form.Metadatos = result.Metadatos
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return null
    },
  }

}
</script>
